import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as React from "react";

export default function MeteringModeSelect({ value, onChange, disabled = false }) {
  return (
    <FormControl fullWidth>
      <InputLabel>Metering mode</InputLabel>
      <Select
        value={value}
        label="Metering mode"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        <MenuItem value={0}>Grid</MenuItem>
        <MenuItem value={1}>Internal</MenuItem>
        <MenuItem value={2}>Logging</MenuItem>
      </Select>
    </FormControl>
  );
}
